// @ts-nocheck

import PropTypes from 'prop-types';
import React from 'react';
import { BoxV2, Dot } from 'sonata-react-components';

import { BoxStyled, CustomLegendGenderAgeBoxStyle } from './customLegendGenderAgeBox.style';

function CustomLegendGenderAge({ metric }) {
  return (
    <CustomLegendGenderAgeBoxStyle className="customLegendGenderAge">
      <div className="customLegendGenderAge__row">
        <BoxStyled borderColor="tableBorderRow" id="customLegendGenderAge-box-male">
          <BoxV2.Body bgColor="background01" className="customLegendGenderAge__itemBoxMale" padding="8px">
            <Dot color="#5c53a5" label="Male" />
          </BoxV2.Body>
        </BoxStyled>
        <BoxStyled borderColor="tableBorderRow" id="customLegendGenderAge-box-female">
          <BoxV2.Body bgColor="background01" className="customLegendGenderAge__itemBoxMale" padding="8px">
            <Dot color="#eb7f86" label="Female" />
          </BoxV2.Body>
        </BoxStyled>
      </div>
      <div className="customLegendGenderAge__row">
        <BoxStyled borderColor="tableBorderRow" id="customLegendGenderAge-box-itemBoxXCategory">
          <BoxV2.Body bgColor="background01" className="customLegendGenderAge__itemBoxXCategory" padding="8px">
            <i className="fal fa-street-view customLegendGenderAge__icon" />
            X-axis
            <div className="customLegendGenderAge__xValue">Age</div>
          </BoxV2.Body>
        </BoxStyled>
        <BoxStyled borderColor="tableBorderRow" id="customLegendGenderAge-box-itemBoxYCategory">
          <BoxV2.Body bgColor="background01" className="customLegendGenderAge__itemBoxYCategory" padding="8px">
            <i className="fal fa-street-view customLegendGenderAge__icon" />
            Y-axis
            <div className="customLegendGenderAge__yValue">{metric || 'Impressions'}</div>
          </BoxV2.Body>
        </BoxStyled>
      </div>
    </CustomLegendGenderAgeBoxStyle>
  );
}

CustomLegendGenderAge.propTypes = {
  metric: PropTypes.string
};

export default React.memo(CustomLegendGenderAge);
